import React from 'react';
import PropTypes from 'prop-types';
import FaCreditCard from 'react-icons/lib/fa/credit-card';

const size = 45;

function CardImage({ url }) {
  const cardUrlBase = 'https://cdn.anow.com/images/icons/credit-cards/'
  return (
    <img
      src={`${cardUrlBase}${url}.png`}
      srcSet={`${cardUrlBase}${url}.png 1x, ${cardUrlBase}${url}-2x.png 2x, ${cardUrlBase}${url}-3x.png 3x`}
      alt="card"
    />
  );
}

CardImage.propTypes = {
  url: PropTypes.string.isRequired,
};

const PaymentMethod = ({ brand }) => {
  switch (brand) {
    case 'visa':
      return <CardImage url="VISA" />;
    case 'mastercard':
      return <CardImage url="MasterCard" />;
    case 'amex':
      return <CardImage url="AMERICAN_EXPRESS" />;
    default:
      return <FaCreditCard size={size} />;
  }
};

PaymentMethod.propTypes = {
  brand: PropTypes.string,
};
PaymentMethod.defaultProps = {
  brand: null,
};

export default PaymentMethod;
